<iss-form-field [showNecessity]="showNecessity">
  <iss-label>{{ label || ('iss-wo-common.label.service-location' | translate) }}</iss-label>
  <wo-service-location-input
    [formControl]="control.control"
    [readonly]="readonly"
    [loading]="loading"
    [forceTypeahead]="forceTypeahead"
    [siteId]="siteId"
    [placeholder]="placeholder"
    [withAll]="withAll"
    [role]="role"
    [clearable]="clearable"
  />
  <ng-template issFormFieldError let-errors>
    <ng-container *ngIf="errors.required">{{ 'iss-core.error.required' | translate }}</ng-container>
  </ng-template>
</iss-form-field>
